import { useMemo } from 'react';
import useTradeFormEstimatedLiquidationPrice from 'src/hooks/Liquidations/useTradeFormEstimatedLiquidationPrice';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';
import { useShallow } from 'zustand/react/shallow';

export default function useIsStopLossBeyondLiquidationPrice() {
	const [isTpSlCheckboxChecked, bracketOrders, side] = useVelocityStore(
		useShallow((s) => [
			s.tradeForm.isTpSlCheckboxChecked,
			s.tradeForm.bracketOrders,
			s.tradeForm.side,
		])
	);

	const estimatedLiquidationPrice = useTradeFormEstimatedLiquidationPrice();

	return useMemo(() => {
		if (!isTpSlCheckboxChecked || !bracketOrders?.stopLoss) {
			return false;
		}

		const { price } = bracketOrders.stopLoss;

		if (!estimatedLiquidationPrice || estimatedLiquidationPrice <= 0) {
			return false;
		}

		return side === 'buy'
			? (price?.toNum() ?? 0) <= estimatedLiquidationPrice
			: (price?.toNum() ?? 0) >= estimatedLiquidationPrice;
	}, [
		isTpSlCheckboxChecked,
		bracketOrders?.stopLoss,
		side,
		estimatedLiquidationPrice,
	]);
}
